
export async function getPicklistItems() {
	try {
		const token = window.Liferay.authToken;

		const response = await fetch(
			`/o/headless-admin-list-type/v1.0/list-type-definitions`,
			{
				headers: {
					'x-csrf-token': `${token}`,
				},
			}
		);

		if (!response.ok) {
			throw new Error(
				`Failed to fetch picklist items: ${response.statusText}`
			);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error("Error fetching picklist items:", error);
		return [];
	}
}
